import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home'
import HomeView from '@/views/Home/HomeView.vue'
import szbj from '@/views/szbj/index.vue'
import sx from '@/views/sx/index.vue'
import sjfw from '@/views/sjfw/index.vue'
import gywm from '@/views/gywm/index.vue'
import test from '@/views/testApi/index.vue'
import supermarket from '@/views/supermarket'
import Dataset from "@/views/Dataset/index.vue"
import DatasetItem from "@/views/DatasetItem"
import login from "@/views/Login"
import Backend from "@/views/Backend"
import release from "@/views/Backend/components/release"
import updataUser from "@/views/Backend/components/updataUser"
import uploadUser from "@/views/Backend/components/uploadUser"
import updataPassword from "@/views/Backend/components/updataPassword"
import Published from "@/views/Backend/components/Published"
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }

  {
    path:'/',
    name:Home,
    component:Home,
    redirect: '/HomeView' ,
    children:[{
      path:'/HomeView',
      name:HomeView,
      component:HomeView
    },
    {
      path:'/szbj',
      name:szbj,
      component:szbj
    },
    {
      path:'/sx',
      name:sx,
      component:sx
    },
    {
      path:'/sjfw',
      name:sjfw,
      component:sjfw
    }, {
      path:'/gywm',
      name:gywm,
      component:gywm
    },
    {
      path:'/supermarket',
      name:supermarket,
      component:supermarket
    }
  ]
  },
  {
    path:'/test',
    name:'test',
    component:test
  },
  {
    path:'/Dataset',
    name:'Dataset',
    component:Dataset
  },{
    path:'/DatasetItem',
    name:'DatasetItem',
    component:DatasetItem,
  
  },
  {
    path:'/login',
    name:'login',
    component:login
  },
  // {
  //   path:'/Backend',
  //   name:'Backend',
  //   component:Backend,

  //   children:[{
  //     path:'/release',
  //     name:'release',
  //     component:release
  //   },{
  //     path:'/updataUser',
  //     name:'updataUser',
  //     component:updataUser
  //   },{
  //     path:'/uploadUser',
  //     name:'uploadUser',
  //     component:uploadUser
  //   },{
  //     path:'/updataPassword',
  //     name:'updataPassword',
  //     component:updataPassword
  //   },{
  //     path:'/Published',
  //     name:'Published',
  //     component:Published
  //   }]
  // },
 
]

const router = new VueRouter({
  mode: "history",
  routes,
})

export default router
